/* eslint-disable no-underscore-dangle */
import { DateSchema } from 'yup';
import convertDate from '@shared/utils/convertDate';
import {
	isValid,
	isDate,
	newDate,
	isAfter,
	isBefore,
	isEqual,
} from 'date-fns-jalali';

class JalaliDateSchema extends DateSchema {
	_typeCheck(value) {
		if (value?.toString() === 'Invalid Date') {
			return false;
		}

		const { year, month, day, hours, minutes } = convertDate(value);
		const date = newDate(year, month - 1, day, hours, minutes);

		return (
			super._typeCheck(value) || (isDate(date) && isValid(date))
		);
	}

	// Prevents bugs like: '1401/12/3' > '1401/12/29' //=> true
	max(maxValue, message) {
		return this.test('max', message, (value) => {
			const {
				year: enteredYear,
				month: enteredMonth,
				day: enteredDay,
			} = convertDate(value);
			const enteredDate = newDate(
				enteredYear,
				enteredMonth - 1,
				enteredDay,
			);
			const {
				year: maxYear,
				month: maxMonth,
				day: maxDay,
			} = convertDate(maxValue);
			const maxDate = newDate(maxYear, maxMonth - 1, maxDay);

			return (
				isBefore(enteredDate, maxDate) || isEqual(enteredDate, maxDate)
			);
		});
	}

	// Prevents bugs like: '1399/7/6' > '1399/07/7' //=> true
	min(minValue, message) {
		return this.test('min', message, (value) => {
			const {
				year: enteredYear,
				month: enteredMonth,
				day: enteredDay,
			} = convertDate(value);
			const enteredDate = newDate(
				enteredYear,
				enteredMonth - 1,
				enteredDay,
			);
			const {
				year: minYear,
				month: minMonth,
				day: minDay,
			} = convertDate(minValue);
			const minDate = newDate(minYear, minMonth - 1, minDay);

			return (
				isAfter(enteredDate, minDate) || isEqual(enteredDate, minDate)
			);
		});
	}

	required(message) {
		return this.test('required', message, function(value) {
			const { path, createError } = this;
			return !!value?.length || createError({
				path,
				message,
			});
		});
	};
}

export default () => new JalaliDateSchema();
